import { IOrderNote } from '../../../../../../../../../app/entities/OrderNote'
import { IOrderVehicle } from '../../../../../../../../../app/entities/OrderVehicle'

/**
 * Builds the REWORK reason note surfaced to the technician.
 */
export function buildReasonNote(
  techName: string | undefined | null,
  reason: string,
): string {
  const name = techName?.trim() || 'Unknown'
  return `OG Technician: ${name}\nReason for REWORK: ${reason.trim()}`
}

/**
 * Collapses all of the OG work order's technician-facing notes into a single
 * pipe-delimited note. Includes technician notes, legacy notes, on-site
 * cancellation (OSC) data, and the deprecated order.note field. Excludes
 * activity_log entries (e.g. "Cloned from WO#...") and note authorship.
 *
 * Returns null when there is nothing to carry over.
 */
export function buildOgNotesNote(
  ogNotes: IOrderNote[],
  orderVehicles: IOrderVehicle[],
  legacyNote: string | null | undefined,
): string | null {
  const parts: string[] = []

  // Technician + legacy notes from the orderNotes entity (skip activity_log)
  ogNotes
    .filter((note) => note.type !== 'activity_log')
    .forEach((note) => {
      const content = note.content?.trim()
      if (content) parts.push(content)
    })

  // On-site cancellation data lives on order vehicles, not orderNotes
  ;(orderVehicles || []).forEach((vehicle) => {
    const cosFields = [
      vehicle.cosReason1,
      vehicle.cosReason2,
      vehicle.cosReason3,
      vehicle.cosNote,
    ]
      .map((field) => field?.trim())
      .filter((field): field is string => !!field)
    if (cosFields.length) parts.push(`OSC: ${cosFields.join(', ')}`)
  })

  // Deprecated single order.note field, if it wasn't already migrated into a note
  const legacy = legacyNote?.trim()
  if (legacy && !parts.includes(legacy)) parts.push(legacy)

  if (!parts.length) return null

  return `OG Work Order Notes: ${parts.join(' | ')}`
}
